var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeuDeVia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 287 276",
    style: {
      enableBackground: "new 0 0 287 276"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Welcome"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Inici",
    transform: "translate(-817.000000, -379.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(817.000000, 379.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M231.77,148.14l-82.94,48.06c-3.6,2.08-8.06,2.08-11.66,0l-67.2-38.93L198.96,82.5 c1.77-1.03,3.79-1.57,5.83-1.57h32.81V138C237.61,142.17,235.37,146.05,231.77,148.14 M51.26,145.64l89.59-51.9 c1.77-1.03,3.79-1.57,5.83-1.57h26.81L65.58,154.71l-11.35-6.58C53.08,147.48,52.1,146.62,51.26,145.64 M48.39,138v-13.12 l34.41-19.94c1.77-1.03,3.79-1.57,5.83-1.57h26.81l-66.37,38.46C48.64,140.61,48.39,139.32,48.39,138 M54.23,54.19l82.94-48.06 c1.8-1.04,3.81-1.56,5.83-1.56s4.03,0.52,5.83,1.56l82.94,48.06c3.6,2.08,5.83,5.97,5.83,10.13v12.2H204.8 c-2.81,0-5.59,0.75-8.03,2.16l-15.66,9.08h-34.42c-2.81,0-5.59,0.75-8.03,2.16l-15.6,9.04H88.63c-2.82,0-5.59,0.75-8.03,2.16 l-32.21,18.67V64.33C48.39,60.16,50.63,56.27,54.23,54.19 M233.97,50.37L151.03,2.32c-4.95-2.87-11.1-2.87-16.06,0L52.03,50.37 C47.08,53.24,44,58.59,44,64.33V138c0,5.74,3.08,11.08,8.03,13.95l82.94,48.06c2.48,1.43,5.25,2.15,8.03,2.15 s5.55-0.72,8.03-2.15l82.94-48.06c4.95-2.87,8.03-8.22,8.03-13.95V64.33C242,58.59,238.92,53.24,233.97,50.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "st0",
    d: "M8.62,260.86c8.79,0,12.07-4.59,12.07-11.01c0-6.42-3.28-11.01-12.07-11.01H4.14v22.02H8.62z  M0,235.16h8.85c10.69,0,16.15,5.91,16.15,14.68c0,8.6-5.46,14.63-16.15,14.63H4.14v9.69H0V235.16z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    className: "st0",
    points: "34,235.16 58.18,235.16 58.18,238.83 38.21,238.83 38.21,256.05 54.92,256.05  54.92,259.66 38.21,259.66 38.21,270.49 59,270.49 59,274.16 34,274.16  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    className: "st0",
    d: "M68,261.21v-26.05h4.13v25.76c0,7.03,3.79,10.52,9.87,10.52c6.02,0,9.87-3.49,9.87-10.52v-25.76 H96v26.05c0,9.25-6.08,13.95-14,13.95C74.02,275.16,68,270.46,68,261.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    className: "st0",
    d: "M127.31,270.44c11.69,0,17.27-6.48,17.27-15.77s-5.58-15.77-17.27-15.77h-5.12v31.54H127.31z  M118,235.16h9.6c13.2,0,21.4,7.69,21.4,19.5c0,11.81-8.14,19.5-21.4,19.5H118V235.16z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    className: "st0",
    points: "156,235.16 180.18,235.16 180.18,238.83 160.21,238.83 160.21,256.05 176.92,256.05  176.92,259.66 160.21,259.66 160.21,270.49 181,270.49 181,274.16 156,274.16  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    className: "st0",
    d: "M198,235.16h4.69l11.24,26.84c0.84,1.98,1.74,5.36,1.74,5.36s0.9-3.38,1.74-5.36l11.19-26.84 H233l-17.02,40h-0.72L198,235.16z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    className: "st0",
    points: "241,274.16 246,274.16 246,235.16 241,235.16  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    className: "st0",
    d: "M278.1,263.92l-7.22-17.58c-0.78-1.86-1.56-4.72-1.56-4.72s-0.84,2.85-1.62,4.72l-7.22,17.58 H278.1z M268.96,234.16h0.72l17.32,40h-4.57l-2.77-6.64h-20.69l-2.71,6.64H252L268.96,234.16z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeuDeVia);
export default __webpack_public_path__ + "static/media/peu-de-via.b13582f9dbbf16c6c2733996a7304474.svg";
export { ForwardRef as ReactComponent };